import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cinema-modify__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "修改影片信息", -1)
const _hoisted_3 = { class: "cinema-modify__body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "待修改影片", -1)
const _hoisted_5 = { class: "info-box" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tags" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "origin info-row mt-14" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "主演：", -1)
const _hoisted_13 = { class: "origin info-row mt-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "导演：", -1)
const _hoisted_15 = { class: "origin info-row mt-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "简介：", -1)
const _hoisted_17 = {
  key: 0,
  class: "drama-series"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "单集", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-caret-down" }, null, -1)
const _hoisted_20 = { class: "episode-selector" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "全集修改", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-circle-play" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "单集修改", -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "icomoon-circle-play" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "目标影片", -1)
const _hoisted_27 = { class: "search-box" }
const _hoisted_28 = {
  key: 0,
  class: "info search-result-item-selected"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "tags" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "origin info-row mt-14" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "主演：", -1)
const _hoisted_35 = { class: "origin info-row mt-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "导演：", -1)
const _hoisted_37 = { class: "origin info-row mt-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", null, "简介：", -1)
const _hoisted_39 = { class: "search-results-wrap" }
const _hoisted_40 = {
  key: 0,
  class: "search-results"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "你可能想找", -1)
const _hoisted_42 = {
  key: 0,
  class: "search-result-box"
}
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "tags" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "origin info-row mt-14" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", null, "主演：", -1)
const _hoisted_50 = { class: "origin info-row mt-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "导演：", -1)
const _hoisted_52 = { class: "origin info-row mt-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "简介：", -1)
const _hoisted_54 = {
  key: 1,
  class: "search-result-abnormal"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "cinema-feedback__footer" }

import { PropType, ref, onMounted } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { toast } from '@remote/utils/dialog'
import { checkNetworkState } from '@remote/store/utils'
import PopWrapper from '@remote/components/PopWrapper.vue'
import Button from '@remote/components/Button.vue'
import { 
  getDramas as getDramasApi, 
  searchResource as searchResourceApi,
  updateResource as updateResourceApi,
  updateAllResource as updateAllResourceApi,
  ISearchResourceRetItem,
} from '@remote/api/nfo'
import throttle from 'lodash/throttle'
import { useCinemaStore, cinemaEventBus, cinemaEventBusEvents } from '@remote/store/cinema'

type TSearchResourceRetItem = {
  class: string
  id: string
  name: string
  actors: string[]
  directors: string[]
  brief:string
  postUrl:string
  year:string
  originPlace:string
  scrapeData: ISearchResourceRetItem
}


export default /*#__PURE__*/_defineComponent({
  props: {
  nfo: {
    type: Object as PropType<API_NFO.NFO>,
    required: true,
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { isShow, close } = usePromisifyDialog(emit)
const cinemaStore = useCinemaStore()
const isMovie = props.nfo?.scrape_result?.class === 'movie'
const cinemaType =  isMovie ? '电影' : '电视剧'
const cinemaYear = props.nfo?.scrape_result?.year || ''
const cinemaOriginPlace = props.nfo?.scrape_result?.origin_place || ''
const cinemaActors = props.nfo?.scrape_result?.actors || ['未知']

console.log('props.nfo', props.nfo)


const dramaSeries = ref<Array<{id: string; displayName: string}>>([])
// 全集剧名称
const fullAramaSeriesDisplayName = ref([
  props.nfo?.scrape_result?.short_name || props.nfo.scrape_result?.trans_name || props.nfo.scrape_result?.name,
  props.nfo?.scrape_result?.season ? `第${props.nfo.scrape_result.season}季` : '',
  '全集',
].filter(label => !!label).join('·'))
// 当前集名称
const currentDramaSeriesDisplayName = ref([
  props.nfo?.scrape_result?.short_name || props.nfo.scrape_result?.trans_name || props.nfo.scrape_result?.name,
  props.nfo?.scrape_result?.season ? `第${props.nfo.scrape_result.season}季` : '',
  props.nfo?.scrape_result?.episode ? `第${props.nfo?.scrape_result?.episode}集` : '',
].filter(label => !!label).join('·'))
// 当前剧集文件id
const currentDramaFileId = ref(props.nfo.video_info?.file_id)
const searchName = ref('')
const offline = ref(false)

const searchResults = ref<TSearchResourceRetItem[]>([])
const selectedSearchResultsItem = ref<TSearchResourceRetItem|null>()

const visibleEpisodeSelector = ref(false)
const handleOnToggleVisibleEpisodeSelector = () => {
  visibleEpisodeSelector.value = !visibleEpisodeSelector.value
}
const handleOnSelectDrama = (id = '') => {
  currentDramaFileId.value = id
  if (id) {
    currentDramaSeriesDisplayName.value = dramaSeries.value.find(item => item.id === id)?.displayName as string
  } else {
    currentDramaSeriesDisplayName.value = fullAramaSeriesDisplayName.value
  }
  handleOnToggleVisibleEpisodeSelector()
}

const handleOnSearchResource = throttle((evt) => {
  const name = evt.target.value
  offline.value = !navigator.onLine
  if(name) searchResourceApi({name, limit: 50})
    .then(res => {
      const [error, result] = res
      if (!error && result.ret === 0 && result?.data?.length) {
        searchResults.value = result?.data.map(item => {
          return ({
            class: item.class,
            id: item.xmdb_id,
            name: item.trans_name || item.name || item.title,
            actors: item.actors.map(actor => actor.name),
            directors: item.directors.map(director => director.name),
            brief: item.brief,
            postUrl:item.post_url[0],
            year: item.year,
            originPlace: item.origin_place,
            scrapeData: item,
          })
        })
      }
    })
}, 1000)

const handleOnSelectSearchResults = (item:TSearchResourceRetItem) => {
  selectedSearchResultsItem.value = item
  searchResults.value = []
  searchName.value = ''
}

const onConfirm = async () => {
  if (!selectedSearchResultsItem.value) return
  if (checkNetworkState()) return

  try {
    const updateApi = currentDramaFileId.value ? updateResourceApi : updateAllResourceApi
    const fileId = props.nfo.video_info?.file_id as string
    const params = {
      file_id: fileId,
      scrape_id: props.nfo.scrape_result?.id,
      scrape_data: selectedSearchResultsItem.value.scrapeData,
    }

    const [err, res] = await updateApi(params)
    if (err || res.ret !== 0) {
      toast({type: 'error', message: `修改失败:${err?.error_description}`})
    } else {
      toast({type: 'success', message: '修改成功'})
      close(true)
      cinemaEventBus.trigger(cinemaEventBusEvents.modifyCinema, fileId)
      cinemaStore.createScrapeTask('manual_btn_click')
    }
  } catch(err) {
    toast({type: 'error', message: `修改失败:${err}`})
  }
}

onMounted(async () => {
  if (!isMovie) {
    const getDramasRet = await getDramasApi(props.nfo.scrape_result?.id as number, 200)
    if (getDramasRet?.length) {
      console.log('dramaSeries', getDramasRet)
      dramaSeries.value = getDramasRet.map(drama => {
        const name = drama.short_name || drama.trans_name || drama.name
        const season = drama.season ? +drama.season : 0
        const episode = drama.episode ? +drama.episode : 0
        const displayName = [
          name,
          season ? `第${season}季` : '',
          episode ? `第${episode}集` : '',
        ].filter(label => !!label).join('·')

        return {
          id: drama.file_id,
          displayName: displayName || drama.file_name,
        }
      })
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: _unref(close),
    "is-show": _unref(isShow)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "cinema-modify is-dark",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            class: "cancel",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
          }, "取消"),
          _createElementVNode("span", {
            class: _normalizeClass({
            'submit': true,
            'is-disabled': !selectedSearchResultsItem.value
          }),
            onClick: onConfirm
          }, "提交", 2),
          _createElementVNode("i", {
            class: "icomoon-close head-close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "poster",
                src: __props.nfo?.scrape_result?.poster_vertical ?? ''
              }, null, 8, _hoisted_7),
              _createElementVNode("div", null, [
                _createElementVNode("h4", null, _toDisplayString(__props.nfo?.scrape_result?.trans_name ?? ''), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_unref(cinemaType)), 1),
                  (_unref(cinemaYear))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(cinemaYear)), 1))
                    : _createCommentVNode("", true),
                  (_unref(cinemaOriginPlace))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(cinemaOriginPlace)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(_unref(cinemaActors).join('、')), 1)
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(_toDisplayString(__props.nfo?.scrape_result?.director || '未知'), 1)
                ]),
                _createElementVNode("p", _hoisted_15, [
                  _hoisted_16,
                  _createTextVNode(_toDisplayString(__props.nfo?.scrape_result?.biref || '无'), 1)
                ])
              ])
            ]),
            (!isMovie)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "target-episode",
                    onClick: handleOnToggleVisibleEpisodeSelector
                  }, [
                    _hoisted_18,
                    _createElementVNode("div", null, _toDisplayString(currentDramaSeriesDisplayName.value), 1),
                    _hoisted_19
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", {
                      class: _normalizeClass(["episode-item", {active: !currentDramaFileId.value}]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOnSelectDrama()))
                    }, [
                      _hoisted_22,
                      _createElementVNode("div", null, _toDisplayString(fullAramaSeriesDisplayName.value), 1)
                    ], 2),
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dramaSeries.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: _normalizeClass(["episode-item", {active: item.id === currentDramaFileId.value}]),
                        onClick: ($event: any) => (handleOnSelectDrama(item.id))
                      }, [
                        _hoisted_25,
                        _createElementVNode("div", null, _toDisplayString(item.displayName), 1)
                      ], 10, _hoisted_24))
                    }), 128))
                  ], 512), [
                    [_vShow, visibleEpisodeSelector.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            (selectedSearchResultsItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("img", {
                    class: "poster",
                    src: selectedSearchResultsItem.value?.postUrl
                  }, null, 8, _hoisted_29),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", null, _toDisplayString(selectedSearchResultsItem.value.name), 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", null, _toDisplayString(selectedSearchResultsItem.value.class === 'tv' ? '电视剧': '电影'), 1),
                      (selectedSearchResultsItem.value.year)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(selectedSearchResultsItem.value.year), 1))
                        : _createCommentVNode("", true),
                      (selectedSearchResultsItem.value.originPlace)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(selectedSearchResultsItem.value.originPlace), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_33, [
                      _hoisted_34,
                      _createTextVNode(_toDisplayString(selectedSearchResultsItem.value?.actors?.join('、')), 1)
                    ]),
                    _createElementVNode("p", _hoisted_35, [
                      _hoisted_36,
                      _createTextVNode(_toDisplayString(selectedSearchResultsItem.value.directors?.join('、') || '未知'), 1)
                    ]),
                    _createElementVNode("p", _hoisted_37, [
                      _hoisted_38,
                      _createTextVNode(_toDisplayString(selectedSearchResultsItem.value.brief || '无'), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", {
              placeholder: "请输入目标影片的名称",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleOnSearchResource) && _unref(handleOnSearchResource)(...args))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchName).value = $event))
            }, null, 544), [
              [_vModelText, searchName.value]
            ]),
            _createElementVNode("div", _hoisted_39, [
              (!!searchName.value || !!searchResults.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    (searchResults.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.xmdb_id,
                              class: _normalizeClass(["info search-result-item", {active: selectedSearchResultsItem.value && selectedSearchResultsItem.value?.id === item.id}]),
                              onClick: ($event: any) => (handleOnSelectSearchResults(item))
                            }, [
                              _createElementVNode("img", {
                                class: "poster",
                                src: item?.postUrl
                              }, null, 8, _hoisted_44),
                              _createElementVNode("div", null, [
                                _createElementVNode("h4", null, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("span", null, _toDisplayString(item.class === 'tv' ? '电视剧': '电影'), 1),
                                  (item.year)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(item.year), 1))
                                    : _createCommentVNode("", true),
                                  (item.originPlace)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(item.originPlace), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_48, [
                                  _hoisted_49,
                                  _createTextVNode(_toDisplayString(item?.actors?.join('、')), 1)
                                ]),
                                _createElementVNode("p", _hoisted_50, [
                                  _hoisted_51,
                                  _createTextVNode(_toDisplayString(item.directors?.join('、') || '未知'), 1)
                                ]),
                                _createElementVNode("p", _hoisted_52, [
                                  _hoisted_53,
                                  _createTextVNode(_toDisplayString(item.brief || '无'), 1)
                                ])
                              ])
                            ], 10, _hoisted_43))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          (offline.value)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_55))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", null, _toDisplayString(offline.value ? '网络异常' : '没有搜索到符合描述的内容，请换个搜索词后试试吧~'), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(Button, {
              onClick: onConfirm,
              text: "确认修改",
              size: "middle",
              disabled: !selectedSearchResultsItem.value
            }, null, 8, ["disabled"]),
            _createVNode(Button, {
              onClick: _unref(close),
              text: "取消",
              type: "cancel",
              size: "middle"
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["close", "is-show"]))
}
}

})